module.exports = __webpack_public_path__ + "static/media/image_5.b167c13b.png";